<template>
	<div v-loading="loading" class="upload-container">
		<el-button v-if="btnShow" icon="el-icon-upload" :size="btnSize" :type="btnType" :plain="btnPlain"
			@click="handleOpen" class="file-manager-btn">
			{{ btnMSg }}
		</el-button>

		<el-dialog title="文件管理" custom-class="upload-dialog" :visible.sync="DialogVisible" :width="width"
			:close-on-click-modal="true" :close-on-press-escape="false" :append-to-body="true">
			<!-- 顶部操作栏 -->
			<div class="upload-header mb16 clearfix">
				<div class="upload-actions">
					<el-upload class="avatar-uploader" ref="upload" :action="action" :name="name" :data="uploadData"
						:accept="accept" :headers="AHeader" :before-upload="handleBeforeUpload"
						:on-success="handleUploadSuccess" :multiple="true" :show-file-list="false">
						<el-button class="upload-button" size="small" type="primary" icon="el-icon-upload">上传文件</el-button>
					</el-upload>
					<div class="selected-info" v-if="selectedCount > 0">
						已选择 {{ selectedCount }} 个文件
					</div>
				</div>
			</div>

			<!-- 主体内容 -->
			<div class="file-manager-body">
				<!-- 分类侧边栏 -->
				<div class="category-sidebar">
					<div class="sidebar-header">
						<span>文件分类</span>
						<!-- <el-button 
							type="text" 
							icon="el-icon-plus" 
							@click="handleAddCategory"
							class="add-category-btn">
							添加
						</el-button> -->
					</div>
					<ul class="category-list">
						<li v-for="(item, index) in Cates.pageData" :key="index"
							:class="['category-item', { active: Cates.active === index }]" 
							@click="handleCategoryClick(index)">
							<span class="category-name">{{ item.name }}</span>
							<div v-if="item.id" class="category-actions" @click.stop>
								<el-tooltip content="编辑" placement="top">
									<i class="el-icon-edit" @click="handleEditCategory(item)"></i>
								</el-tooltip>
								<el-tooltip content="删除" placement="top">
									<i class="el-icon-delete" @click="handleDeleteCategory(item)"></i>
								</el-tooltip>
							</div>
						</li>
					</ul>
				</div>

				<!-- 文件内容区域 -->
				<div class="file-content-area">
					<div class="file-grid" v-if="Record.pageData.length > 0">
						<div class="file-item" v-for="(item, index) in Record.pageData" :key="index"
							:class="{ selected: Select[item.id] }"
							@click="handleSelectFile(item)">
							<div class="file-select-indicator" v-show="Select[item.id]">
								<i class="el-icon-check"></i>
							</div>
							<div class="file-thumbnail">
								<img :src="getFileIcon(item.path)" :alt="item.name" />
							</div>
							<div class="file-info">
								<p class="file-name">{{ item.name }}</p>
							</div>
							<div class="file-actions" @click.stop>
								<el-tooltip content="删除" placement="top">
									<i class="el-icon-delete" @click="handleDeleteFile(item)"></i>
								</el-tooltip>
							</div>
						</div>
					</div>
					<div class="empty-state" v-else>
						<i class="el-icon-folder-opened"></i>
						<p>暂无文件</p>
						<p class="empty-tip">点击上方"上传文件"按钮添加文件</p>
					</div>
				</div>
			</div>

			<!-- 分页 -->
			<div class="pagination-wrap">
				<el-pagination 
					:current-page="Record.pageInfo._page" 
					:page-size="Record.pageInfo._size"
					:total="Record.pageInfo.total" 
					:page-sizes="[12, 24, 36, 48]"
					layout="total, sizes, prev, pager, next, jumper" 
					@size-change="handlePageSizeChange"
					@current-change="handlePageChange" />
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button class="footer-button" @click="handleCancel">取 消</el-button>
				<el-button class="footer-button" type="primary" @click="handleConfirm" :disabled="selectedCount === 0">确 定</el-button>
			</div>

			<!-- 分类编辑对话框 -->
			<el-dialog 
				width="400px" 
				:visible.sync="InnerVisible" 
				:title="(Cates.pageFrom.id ? '修改' : '添加') + '分类'"
				:close-on-click-modal="true" 
				:close-on-press-escape="false" 
				:append-to-body="true">
				<el-form ref="categoryForm">
					<el-form-item label="分类名称">
						<el-input 
							placeholder="请输入分类名称" 
							v-model="Cates.pageFrom.name"
							@keyup.enter.native="handleSaveCategory" />
					</el-form-item>
				</el-form>
				<div slot="footer">
					<el-button class="footer-button" @click="InnerVisible = false">
						取消
					</el-button>
					<el-button class="footer-button" type="primary" @click="handleSaveCategory">
						保存
					</el-button>
				</div>
			</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
	const CATES = 'app-files-cates';
	const RECORD = 'app-files-record';

	export default {
		name: "PageFiles",
		props: {
			action: {
				type: String,
				default: function() {
					return $config.apihost + '/api.php?r=' + RECORD;
				}
			},
			name: {
				type: String,
				default: "upfile",
			},
			accept: {
				type: String,
				default: '.png,.jpg,.jpeg,.xlsx,.pdf,.xls'
			},
			appname: {
				type: String,
				default: ''
			},
			headers: {
				type: Object,
				default: function() {
					return {};
				}
			},
			limit: {
				type: Number,
				default: 3,
			},
			split: {
				type: String,
				default: ''
			},
			btnShow: {
				type: Boolean,
				default: true,
			},
			btnMSg: {
				type: String,
				default: "文件管理",
			},
			btnPlain: {
				type: Boolean,
				default: false,
			},
			btnSize: {
				type: String,
				default: "small",
			},
			btnType: {
				type: String,
				default: "primary",
			},
			width: {
				type: String,
				default: "910px",
			},
		},
		data() {
			return {
				loading: false,
				InnerVisible: false,
				DialogVisible: false,
				AHeader: {},
				ALoading: null,
				Cates: {
					active: 0,
					pageFrom: {},
					pageData: [{
						name: '全部'
					}],
				},
				Record: {
					pageInfo: {
						_page: 1,
						_size: 24,
					},
					pageData: [],
				},
				Select: {},
			};
		},
		computed: {
			uploadData() {
				const activeCategory = this.Cates.pageData[this.Cates.active];
				const data = {
					appname: this.appname
				};
				if (activeCategory && activeCategory.id) {
					data.cateid = activeCategory.id;
				}
				return data;
			},
			selectedCount() {
				return Object.keys(this.Select).length;
			}
		},
		created() {
			this.init();
		},
		methods: {
			// 初始化
			init() {
				this.AHeader = Object.assign({}, this.headers, this.$apimit.permit());
				this.loadCategories();
			},

			// 对话框控制
			open() {
				this.Select = {};
				this.DialogVisible = true;
				if (this.Cates.pageData.length === 1) {
					this.loadCategories();
				}
				return this;
			},

			close() {
				this.DialogVisible = false;
				this.InnerVisible = false;
				return this;
			},

			handleOpen() {
				this.DialogVisible = true;
			},

			handleCancel() {
				this.DialogVisible = false;
			},

			// 上传相关
			handleBeforeUpload() {
				this.AHeader = Object.assign({}, this.headers, this.$apimit.permit());
				this.ALoading = this.$loading({
					lock: true,
					text: '文件上传中,请等待',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},

			handleUploadSuccess(res) {
				if (this.ALoading) {
					this.ALoading.close();
				}

				if (res && res.code === 0) {
					this.loadCategories();
					this.$message.success('上传成功');
				} else {
					this.$message.warning((res && res.msg) || '上传失败');
				}
			},

			// 分类管理
			loadCategories() {
				this.loadFiles();
			},

			handleCategoryClick(index) {
				this.Cates.active = index;
				this.loadFiles();
			},
			
			handleAddCategory() {
				this.Cates.pageFrom = {};
				this.InnerVisible = true;
			},

			handleEditCategory(item) {
				this.Cates.pageFrom = Object.assign({}, item);
				this.InnerVisible = true;
			},

			handleSaveCategory() {
				const categoryData = Object.assign({}, this.Cates.pageFrom, {
					appname: this.appname
				});

				this.loading = true;
				this.$save(CATES, categoryData)
					.then(res => {
						this.loading = false;
						this.InnerVisible = false;
						this.loadCategories();
						this.$message.success((res && res.msg) || '操作成功');
					})
					.catch(err => {
						this.loading = false;
						this.InnerVisible = false;
						this.$message.warning(err || '删除失败');
					});
			},

			handleDeleteCategory(item) {
				if (!item.id) return;

				this.$confirm('确定要删除目录及文件吗?', '提示', {
					type: 'warning',
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(() => {
					this.loading = true;
					this.$del(CATES + '/' + item.id)
						.then(res => {
							this.loading = false;
							this.Select = {};
							this.loadCategories();
							this.$message.success((res && res.msg) || '操作成功');
						})
						.catch(err => {
							this.loading = false;
							this.$message.warning(err || '删除失败');
						});
				});
			},

			// 文件管理
			loadFiles() {
				const params = Object.assign({}, this.Record.pageInfo, {
					appname: this.appname,
					cateid: (this.Cates.pageData[this.Cates.active] && this.Cates.pageData[this.Cates.active]
						.id) || ''
				});

				this.$get(RECORD, params)
					.then(res => {
						this.Record.pageData = res.data || [];
						this.Record.pageInfo.total = (res.extra && res.extra.pageInfo && res.extra.pageInfo.count) ||
						0;
						this.Record.pageInfo._page = (res.extra && res.extra.pageInfo && res.extra.pageInfo.page) || 1;
					})
					.catch(err => {
						this.Record.pageData = [];
						this.Record.pageInfo.total = 0;
						this.Record.pageInfo._page = 1;
					});
			},

			handleDeleteFile(item) {
				if (!item.id) return;

				this.$confirm('确定删除选中的文件吗?', '提示', {
					type: 'warning',
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(() => {
					this.$del(RECORD + '/' + item.id)
						.then(res => {
							this.Select = {};
							this.loadFiles();
							this.$message.success((res && res.msg) || '操作成功');
						})
						.catch(err => {
							this.$message.warning(err || '删除失败');
						});
				});
			},

			// 分页处理
			handlePageSizeChange(size) {
				this.Record.pageInfo._size = size;
				this.Record.pageInfo._page = 1;
				this.loadFiles();
			},

			handlePageChange(page) {
				this.Record.pageInfo._page = page;
				this.loadFiles();
			},

			// 文件选择 - 修改后的逻辑
			handleSelectFile(item) {
				// 如果限制为1，直接替换当前选择
				if (this.limit === 1) {
					// 清空所有选择
					this.Select = {};
					// 选择当前文件
					this.$set(this.Select, item.id, item);
				} else {
					// 原有的多选逻辑
					if (this.Select[item.id]) {
						this.$delete(this.Select, item.id);
					} else {
						if (this.selectedCount >= this.limit) {
							this.$message.warning('选择最多不能超过 ' + this.limit + ' 个文件');
							return;
						}
						this.$set(this.Select, item.id, item);
					}
				}
			},

			// 路径处理
			getPath(path) {
				return path ? $config.apihost + '/' + path : '';
			},

			getFileIcon(path) {
				if (!path) return '';

				const extension = path.split('.').pop().toLowerCase();
				const iconMap = {
					pdf: require('../../../../../static/basic/file/pdf.png'),
					xlsx: require('../../../../../static/basic/file/xlsx.png'),
					xls: require('../../../../../static/basic/file/xls.png')
				};

				return iconMap[extension] || this.getPath(path);
			},

			// 确认操作
			handleConfirm() {
				const selectedPaths = [];
				for (let id in this.Select) {
					if (this.Select[id]) {
						selectedPaths.push(this.Select[id].path);
					}
				}

				const result = this.split ? selectedPaths.join(this.split) : selectedPaths;
				this.$emit('confirm', result);

				this.InnerVisible = false;
				this.DialogVisible = false;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.footer-button {
		width: 120px;
	}
	
	.mb16 {
		margin-bottom: 16px;
	}

	.upload-container {
		.file-manager-btn {
			border-radius: 4px;
		}
	}

	.upload-header {
		.upload-actions {
			display: flex;
			justify-content: space-between;
			align-items: center;
			
			.selected-info {
				color: #409EFF;
				font-size: 14px;
				font-weight: 500;
			}
			
			.upload-button {
				background-color: #409EFF;
			}
		}
	}

	.file-manager-body {
		display: flex;
		height: 400px;
		border: 1px solid #e6e6e6;
		border-radius: 4px;
		overflow: hidden;
	}

	.category-sidebar {
		width: 180px;
		background-color: #f8f9fa;
		border-right: 1px solid #e6e6e6;
		display: flex;
		flex-direction: column;
		
		.sidebar-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 12px 16px;
			border-bottom: 1px solid #e6e6e6;
			background-color: #f0f2f5;
			font-weight: 500;
			
			.add-category-btn {
				padding: 0;
				color: #409EFF;
			}
		}
		
		.category-list {
			flex: 1;
			overflow-y: auto;
			padding: 8px 0;
			
			.category-item {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 10px 16px;
				cursor: pointer;
				transition: all 0.2s;
				position: relative;
				
				&:hover {
					background-color: #edf2fc;
					
					.category-actions {
						display: flex;
					}
				}
				
				&.active {
					background-color: #409EFF;
					color: white;
					
					.category-actions {
						display: flex;
						color: white;
					}
				}
				
				.category-name {
					flex: 1;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				
				.category-actions {
					display: none;
					align-items: center;
					gap: 8px;
					
					i {
						font-size: 14px;
						cursor: pointer;
						
						&:hover {
							color: #ff4d4f;
						}
					}
				}
			}
		}
	}

	.file-content-area {
		flex: 1;
		padding: 16px;
		overflow-y: auto;
		background-color: #fff;
		
		.file-grid {
			display: grid;
			grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
			gap: 16px;
		}
		
		.file-item {
			position: relative;
			border: 1px solid #e6e6e6;
			border-radius: 6px;
			padding: 12px;
			cursor: pointer;
			transition: all 0.3s;
			background-color: #fff;
			
			&:hover {
				border-color: #409EFF;
				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
				
				.file-actions {
					opacity: 1;
				}
			}
			
			&.selected {
				border-color: #409EFF;
				background-color: #f0f7ff;
			}
			
			.file-select-indicator {
				position: absolute;
				top: 8px;
				right: 8px;
				width: 20px;
				height: 20px;
				background-color: #409EFF;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				color: white;
				font-size: 12px;
				z-index: 2;
			}
			
			.file-thumbnail {
				width: 100%;
				height: 80px;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-bottom: 8px;
				overflow: hidden;
				
				img {
					max-width: 100%;
					max-height: 100%;
					object-fit: contain;
				}
			}
			
			.file-info {
				.file-name {
					font-size: 12px;
					text-align: center;
					margin: 0;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
			
			.file-actions {
				position: absolute;
				bottom: 8px;
				right: 8px;
				opacity: 0;
				transition: opacity 0.3s;
				
				i {
					color: #ff4d4f;
					font-size: 14px;
					cursor: pointer;
					
					&:hover {
						color: #ff7875;
					}
				}
			}
		}
		
		.empty-state {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			height: 100%;
			color: #999;
			
			i {
				font-size: 48px;
				margin-bottom: 16px;
			}
			
			p {
				margin: 0;
				font-size: 14px;
			}
			
			.empty-tip {
				font-size: 12px;
				margin-top: 8px;
			}
		}
	}

	.pagination-wrap {
		margin-top: 16px;
		text-align: right;
	}

	.dialog-footer {
		padding-top: 20px;
		text-align: right;
	}

	.el-form-item {
		margin-bottom: 0;
	}

	// 响应式调整
	@media (max-width: 768px) {
		.file-manager-body {
			flex-direction: column;
			height: 500px;
		}
		
		.category-sidebar {
			width: 100%;
			height: 150px;
			border-right: none;
			border-bottom: 1px solid #e6e6e6;
		}
		
		.file-content-area {
			height: 350px;
		}
	}
</style>